// TODO: This file is not used anymore after our refactor, can this as well as other entities be removed? --- IGNORE ---

import { Map } from 'immutable';
import { createSelector } from 'reselect';

import { customerOptionSelector } from '@sophocles/entities/CustomerOption';
import { customerPreferenceSelector } from '@sophocles/entities/CustomerPreference';

export const customerSelector = state => state.entities.customers;

export const selectCustomerById = customerId => state => state.entities.customers.toJS()[customerId];

export const getCustomerSelector = createSelector(customerSelector, customers =>
  customers.map(customer => customer.toMap().set('id_string', '' + customer.get('id', 0))),
);

export const customersWithPreferences = createSelector(
  getCustomerSelector,
  customerPreferenceSelector,
  (customers, preferences) =>
    customers.map(customer =>
      customer.set('preferences', preferences.get(customer.get('preferences', '0') + '', Map())),
    ),
);

export const getCustomersWithPrefsAndOptions = createSelector(
  customersWithPreferences,
  customerOptionSelector,
  (customers, options) =>
    customers.map(customer => customer.set('options', options.get(customer.get('options', 0) + '', Map()))),
);

export const nonProspectCustomersSelector = createSelector(getCustomerSelector, customers =>
  customers.filter(customer => !customer.get('is_prospect', true)),
);

export const customersWithOptions = createSelector(
  nonProspectCustomersSelector,
  customerOptionSelector,
  (customers, options) =>
    customers.map(customer => customer.set('options', options.get(customer.get('options', 0) + '', Map()))),
);

export const thirdPartyMinimalCustomerSelector = createSelector(
  // id, name, sells_digital_panels
  customersWithOptions,
  customers =>
    customers
      .map(customer =>
        Map({
          id: customer.get('id'),
          name: customer.get('name'),
          sells_digital_panels: customer.getIn(['options', 'sells_digital_panels'], false),
        }),
      )
      .toList(),
);
